import React, { FC, useCallback, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  ScrollArea,
  Spinner,
} from "@bandit-network/react-ui-kit";
import { ParticipantsTable } from "../../components/ParticipantsTable";
import { useQuestContext } from "../../context/QuestContext";

interface ParticipantsTypes {
  isOpen: boolean;
  onToggle: () => void;
}

const LIMIT = 12;

const Participants: FC<ParticipantsTypes> = ({ isOpen, onToggle }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [totalResults, setTotalResults] = useState(0);
  const [participants, setParticipants] = useState([]);
  const { questSDK, quest, questId } = useQuestContext();

  const getLeaderBoard = useCallback(async () => {
    try {
      setIsLoading(true);
      const offset = page * LIMIT;
      // @ts-ignore
      const { data, totalResult } = await questSDK.getQuestParticipants({
        collectionId: questId,
        limit: LIMIT,
        offset,
      });
      setParticipants((state) => [...state, ...data]);
      setTotalResults(totalResult);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [questSDK, page, questId]);

  useEffect(() => {
    getLeaderBoard();
  }, [getLeaderBoard]);

  const nextPage = useCallback(() => {
    setPage((page) => page + 1);
  }, [setPage]);
  return (
    <Dialog open={isOpen} onOpenChange={onToggle}>
      <DialogContent
        style={{ maxWidth: "600px" }}
        onPointerDownOutside={(e) => e.preventDefault()}
        className="bad-quest__participants--content"
      >
        <DialogHeader>
          <DialogTitle>{`Participants (${totalResults})`}</DialogTitle>
        </DialogHeader>
        {isLoading ? (
          <div className="bad-quest__participants--loader">
            <Spinner />
          </div>
        ) : !!participants?.length ? (
          <ScrollArea className="bad-quest__participants--scroll_area">
            <ParticipantsTable addresses={participants} />
          </ScrollArea>
        ) : (
          <div className="bad-quest__participants--no_participants">
            <p className="bad-quest__participants--no_participants_text">
              No Participants Found
            </p>
          </div>
        )}
        {participants.length < totalResults && (
          <div className="bad-quest__participants--footer">
            <Button
              variant="outline"
              size="sm"
              className="bad-quest__participants--footer_button"
              onClick={nextPage}
            >
              Load more
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export { Participants };
